import React, { Component, Fragment } from "react";

import { inject, observer } from "mobx-react";

import { Button, Paper, Grid, TextField, FormControl, FormHelperText, Select, Typography, Dialog, DialogTitle, DialogContent, IconButton, MenuItem, Checkbox, ListItemText, Input } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import ActInvitationModal from "../util/ActInvitation/ActInvitationModal";
import ConfirmationModal from "../modal/ConfirmationModal";
import InvoiceAgentActModal from "./InvoiceAgentActModal"
import ActOwnerInvitationModal from "../util/ActOwnerInvitation/ActOwnerInvitationModal";
import Loading from "../loadingSpinner/Loading";
import { withRouter } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import ClearIcon from "@material-ui/icons/Clear";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment"
import HGSuperPayEmployeeModal from "../../components/superPay/HGSuperPayEmployeeModal"
import ActRosterTable from "./actroster/ActRosterTable"
import PaginationToolbar from "./actroster/PaginationToolbar"
import ActDocumentsModal from "./actroster/ActDocumentsModal"
import ActImagesModal from "./actroster/ActImagesModal"
import agent from "../../agent";

@inject("agentActStore", "templateStore", "userInvitationStore", "profileStore", "lookupStore")
@withRouter
@observer
class AgentActRoster extends Component {
    state = {
        actInvitationModalState: false,
        deleteActModalState: false,
        deletedAct: undefined,
        deleteRequestModalState: false,
        actOwnerInvitationModalState: false,
        openActInvoiceSetting: false,
        agentAct: undefined,
        openSuperLedgerDetailsModal: false,
        employeeModalContactId: null,
        employeeModalContactName: "",
        localSearchValue: "",
        lastKnownStoreTerm: "",
        filterActType: "",
        filterLineup: "",
        filterVibes: [],
        filterGenres: [],
        isLoadingGenres: true,
        genreLoadError: false,
        actTypeOptions: [],
        vibeOptions: [],
        isLoadingFilterOptions: true,
        filterOptionsError: false,
        contactDialogOpen: false,
        contactDialogData: null,
        documentsModalOpen: false,
        documentsModalAct: null,
        imagesModalOpen: false,
        imagesModalAct: null
    };

    debounceTimer = null;

    componentDidMount() {
        this.isMountedRoster = true;
        const filters = this.props.agentActStore.rosterFilters;
        this.setState({
            localSearchValue: this.props.agentActStore.actRosterSearchTerm,
            lastKnownStoreTerm: this.props.agentActStore.actRosterSearchTerm,
            filterActType: filters.actTypeId,
            filterLineup: filters.lineupCountId,
            filterVibes: [...filters.vibeIds],
            filterGenres: [...filters.genreIds]
        });
        this.loadGenres();
        this.loadFilterOptions();
        this.props.agentActStore.resumeRosterQuery(this.props.profileStore.getCurrentProfile()?.id);
    }

    loadFilterOptions = () => {
        this.setState({ isLoadingFilterOptions: true, filterOptionsError: false });
        return Promise.all([agent.ActType.getAll(), agent.Vibe.getAll()])
            .then(([actTypeOptions, vibeOptions]) => {
                if (!Array.isArray(actTypeOptions) || !Array.isArray(vibeOptions)) throw new Error("Invalid filter catalog");
                if (this.isMountedRoster) this.setState({ actTypeOptions, vibeOptions });
            })
            .catch(() => {
                if (this.isMountedRoster) this.setState({ filterOptionsError: true });
            })
            .finally(() => {
                if (this.isMountedRoster) this.setState({ isLoadingFilterOptions: false });
            });
    };

    loadGenres = () => {
        this.setState({ isLoadingGenres: true, genreLoadError: false });
        return this.props.lookupStore.getGenreSuggestions()
            .catch(() => {
                if (this.isMountedRoster) this.setState({ genreLoadError: true });
            })
            .finally(() => {
                if (this.isMountedRoster) this.setState({ isLoadingGenres: false });
            });
    };

    componentDidUpdate() {
        const currentStoreTerm = this.props.agentActStore.actRosterSearchTerm;
        const { lastKnownStoreTerm, localSearchValue } = this.state;

        if (currentStoreTerm !== lastKnownStoreTerm && currentStoreTerm !== localSearchValue) {
            this.setState({
                localSearchValue: currentStoreTerm,
                lastKnownStoreTerm: currentStoreTerm
            });
        }
    }

    componentWillUnmount() {
        this.isMountedRoster = false;
        this.props.agentActStore.suspendRosterQuery();
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    handleShowMore = e => {
        var page = this.props.agentActStore.agentActPage + 1;
        this.loadMoreAgentAct(page)
    };

    loadMoreAgentAct = (page) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { agentActStore } = this.props;

        return agentActStore.getAgentActRosterWithPagination(currentProfile?.id, page);
    }

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ localSearchValue: value });
        // Invalidate immediately, not after the debounce: an old response must
        // not appear while the user is already typing a different search.
        this.props.agentActStore.setActRosterSearchTerm(value);

        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            const { agentActStore, profileStore } = this.props;
            agentActStore.setActRosterSearchTerm(value);
            this.setState({ lastKnownStoreTerm: value });

            agentActStore.getAgentActRosterWithPagination(profileStore.getCurrentProfile()?.id, 1);
        }, 500);
    };

    handleClearSearch = () => {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.setState({ localSearchValue: "", lastKnownStoreTerm: "" });
        const { agentActStore, profileStore } = this.props;
        const currentProfile = profileStore.getCurrentProfile();
        agentActStore.clearActRosterSearch();
        agentActStore.resetActRosterForReload();
        return agentActStore.getAgentActRosterWithPagination(currentProfile?.id, 1);
    };

    reloadWithFilters = () => {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        const { agentActStore, profileStore } = this.props;
        agentActStore.setActRosterSearchTerm(this.state.localSearchValue);
        agentActStore.setRosterFilters({
            actTypeId: this.state.filterActType,
            lineupCountId: this.state.filterLineup,
            vibeIds: this.state.filterVibes,
            genreIds: this.state.filterGenres
        });
        return agentActStore.getAgentActRosterWithPagination(profileStore.getCurrentProfile()?.id, 1);
    };

    retryRoster = () => this.props.agentActStore.loadRosterPage(
        this.props.profileStore.getCurrentProfile()?.id,
        this.props.agentActStore.rosterRetryPage,
        this.props.agentActStore.rosterRetryAppend
    );

    handleFilterActTypeChange = (e) => {
        this.setState({ filterActType: e.target.value }, this.reloadWithFilters);
    };

    handleFilterLineupChange = (e) => {
        this.setState({ filterLineup: e.target.value }, this.reloadWithFilters);
    };

    handleFilterVibesChange = (e) => {
        const selected = e.target.value;
        this.setState({ filterVibes: selected.includes("") ? [] : selected }, this.reloadWithFilters);
    };

    handleFilterGenresChange = (e) => {
        const selected = e.target.value;
        this.setState({ filterGenres: selected.includes("") ? [] : selected }, this.reloadWithFilters);
    };

    hasActiveFilters = () => {
        const { filterActType, filterLineup, filterVibes, filterGenres } = this.state;
        return filterActType || filterLineup || filterVibes.length > 0 || filterGenres.length > 0;
    };

    getFilteredActs = () => {
        // The API filters the full roster before pagination.
        return this.props.agentActStore.agentActs;
    };

    getUniqueActTypes = () => {
        return this.state.actTypeOptions;
    };

    getUniqueLineups = () => {
        // Same 1–99 numeric lineup options used by Profile → General.
        return Array.from({ length: 99 }, (_, index) => ({
            id: index + 1,
            name: this.props.agentActStore.getLineUpCounts(index + 1)
        }));
    };

    getUniqueVibes = () => {
        return this.state.vibeOptions;
    };

    getUniqueGenres = () => {
        return [...this.props.lookupStore.genres].sort((a, b) => a.name.localeCompare(b.name));
    };

    selectedNames = (selected, catalog) => selected.map(id =>
        catalog.find(option => String(option.id) === String(id))?.name || String(id)
    ).join(", ");

    openSuperLedgerPreviewDetails = act => {
        this.setState({
            openSuperLedgerDetailsModal: true,
            employeeModalContactId: act.actAdmin ? act.actAdmin.id : null,
            employeeModalContactName: act.actAdmin
                ? (act.actAdmin.profileName || `${act.actAdmin.firstName || ""} ${act.actAdmin.lastName || ""}`.trim())
                : ""
        });
    };

    closeSuperLedgerDetailsModal = () => {
        this.setState({
            openSuperLedgerDetailsModal: false,
            employeeModalContactId: null,
            employeeModalContactName: ""
        });
    };

    createBooking = (actId) => {
        let redirectUrl = `/booking/new?actId=${actId}&venueId=undefined&dateStart=${moment(new Date()).format("DD-MM-YYYY")}`
        this.props.history.push(redirectUrl)
    }

    handleButtonMessage = (act) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if (currentProfile) {
            this.props.history.push({
                pathname: '/messages/new',
                state: { profile: act.actAdmin }
            })
        }
    }

    handleOpenContactDialog = (act) => {
        this.setState({
            contactDialogOpen: true,
            contactDialogData: act
        });
    };

    handleCloseContactDialog = () => {
        this.setState({
            contactDialogOpen: false,
            contactDialogData: null
        });
    };

    handleOpenDocumentsModal = (act) => {
        this.setState({
            documentsModalOpen: true,
            documentsModalAct: act
        });
    };

    handleCloseDocumentsModal = () => {
        this.setState({
            documentsModalOpen: false,
            documentsModalAct: null
        });
    };

    handleOpenImagesModal = (act) => {
        this.setState({
            imagesModalOpen: true,
            imagesModalAct: act
        });
    };

    handleCloseImagesModal = () => {
        this.setState({
            imagesModalOpen: false,
            imagesModalAct: null
        });
    };

    getFilteredActsForTable = () => {
        const filteredActs = this.getFilteredActs();
        const uniqueActs = [];
        const seenIds = new Set();
        
        filteredActs.forEach(data => {
            if (data.act && !seenIds.has(data.act.id)) {
                seenIds.add(data.act.id);
                uniqueActs.push(data);
            }
        });
        
        return uniqueActs;
    };

    openActInvitationModal = () => {
        this.props.agentActStore.openActInvitationModal();
    };

    closeActInvitationModal = () => {
        this.props.agentActStore.closeActInvitationModal();
    };

    openActOwnerInvitationModal = value => {
        this.props.userInvitationStore.resetInvitedData();
        this.setState(
            {
                ...this.state,
                actOwnerInvitationModalState: true,
                actInvitationModalState: false
            },
            () => {
                this.props.userInvitationStore.setInvitedActName(value);
                this.closeActInvitationModal()
            }
        );
    };

    closeActOwnerInvitationModal = () => this.setState({ ...this.state, actOwnerInvitationModalState: false });

    handleDeleteAct = () => {
        this.props.agentActStore.removeAgentAct(this.state.deletedAct.id).then(() => {
            this.props.templateStore.openSnackbar(this.state.deletedAct.act.fullName + " has been removed.");
            this.handleCloseDeleteModal();
        });
    };

    handleOpenDeleteModal = agentAct => {
        this.setState({
            ...this.state,
            deleteActModalState: true,
            deletedAct: agentAct
        });
    };

    handleCloseDeleteModal = () => {
        this.setState({
            ...this.state,
            deleteActModalState: false,
            deletedAct: undefined,
            deleteRequestModalState: false
        });
    };

    handleOpenActInvoiceSetting = (data) => {
        this.setState({
            ...this.state,
            openActInvoiceSetting: true,
            agentAct: data
        });
    };

    handleCloseActInvoiceSetting = () => {
        this.setState({
            ...this.state,
            openActInvoiceSetting: false,
            agentAct: undefined
        });
    };

    render() {
        const { isLoadingAcceptedActs, actInvitationModalState, isSearchingActRoster, actRosterSearchTerm } = this.props.agentActStore;
        const { contactDialogOpen, contactDialogData, filterVibes, filterGenres, documentsModalOpen, documentsModalAct, imagesModalOpen, imagesModalAct, localSearchValue } = this.state;
        const actTypes = this.getUniqueActTypes();
        const lineups = this.getUniqueLineups();
        const vibes = this.getUniqueVibes();
        const genres = this.getUniqueGenres();
        const { isLoadingGenres, genreLoadError, isLoadingFilterOptions, filterOptionsError } = this.state;
        const filteredActs = this.getFilteredActsForTable();
        const hasSearch = actRosterSearchTerm.length > 0;

        return (
            <Fragment>
                <Paper style={{ padding: 30, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                    <div style={{ display: "flex", gap: 15, marginBottom: 8, flexWrap: "wrap", alignItems: "center" }}>
                        <TextField
                            placeholder="Search by act name, owner, or type..."
                            variant="outlined"
                            size="small"
                            value={localSearchValue}
                            onChange={this.handleSearchChange}
                            style={{ flex: 1, minWidth: 200 }}
                            InputProps={{
                                style: { fontSize: 14 },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {isSearchingActRoster ? (
                                            <CircularProgress size={18} style={{ color: "#FF0C9C" }} />
                                        ) : localSearchValue ? (
                                            <IconButton
                                                size="small"
                                                onClick={this.handleClearSearch}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        ) : null}
                                    </InputAdornment>
                                )
                            }}
                        />
                        <FormControl variant="outlined" size="small" style={{ minWidth: 150 }}>
                            <Select
                                native
                                value={this.state.filterActType}
                                onChange={this.handleFilterActTypeChange}
                                disabled={isLoadingFilterOptions || filterOptionsError}
                                inputProps={{ "aria-label": "Act type filter" }}
                                displayEmpty
                            >
                                <option value="">All Act Types</option>
                                {actTypes.map(type => (
                                    <option key={type.id} value={type.id}>{type.name}</option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" style={{ minWidth: 150 }}>
                            <Select
                                native
                                value={this.state.filterLineup}
                                onChange={this.handleFilterLineupChange}
                                inputProps={{ "aria-label": "Lineup filter" }}
                                displayEmpty
                            >
                                <option value="">All Lineups</option>
                                {lineups.map(lineup => (
                                    <option key={lineup.id} value={lineup.id}>{lineup.name}</option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" style={{ minWidth: 150 }}>
                            <Select
                                multiple
                                value={filterVibes}
                                onChange={this.handleFilterVibesChange}
                                disabled={isLoadingFilterOptions || filterOptionsError}
                                inputProps={{ "aria-label": "Vibe filter" }}
                                displayEmpty
                                input={<Input />}
                                renderValue={(selected) => selected.length === 0 ? <span style={{ color: "#888" }}>All Vibes</span> : this.selectedNames(selected, vibes)}
                                style={{ minHeight: 40 }}
                            >
                                <MenuItem value="">
                                    <Checkbox checked={filterVibes.length === 0} color="primary" />
                                    <ListItemText primary="All Vibes" />
                                </MenuItem>
                                {vibes.map(vibe => (
                                    <MenuItem key={vibe.id} value={vibe.id}>
                                        <Checkbox checked={filterVibes.indexOf(vibe.id) > -1} color="primary" />
                                        <ListItemText primary={vibe.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" size="small" style={{ minWidth: 150 }}>
                            <Select
                                multiple
                                value={filterGenres}
                                onChange={this.handleFilterGenresChange}
                                disabled={isLoadingGenres || genreLoadError || genres.length === 0}
                                inputProps={{ "aria-label": "Genre filter" }}
                                displayEmpty
                                input={<Input />}
                                renderValue={(selected) => selected.length === 0 ? <span style={{ color: "#888" }}>All Genres</span> : this.selectedNames(selected, genres)}
                                style={{ minHeight: 40 }}
                            >
                                <MenuItem value="">
                                    <Checkbox checked={filterGenres.length === 0} color="primary" />
                                    <ListItemText primary="All Genres" />
                                </MenuItem>
                                {genres.map(genre => (
                                    <MenuItem key={genre.id} value={genre.id}>
                                        <Checkbox checked={filterGenres.indexOf(genre.id) > -1} color="primary" />
                                        <ListItemText primary={genre.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                            {isLoadingGenres ? (
                                <FormHelperText role="status">
                                    <CircularProgress size={12} /> Loading genres...
                                </FormHelperText>
                            ) : genreLoadError ? (
                                <Fragment>
                                    <FormHelperText error role="alert">Unable to load genres.</FormHelperText>
                                    <Button size="small" onClick={this.loadGenres}>Retry genres</Button>
                                </Fragment>
                            ) : genres.length === 0 ? (
                                <FormHelperText role="status">No genres available.</FormHelperText>
                            ) : null}
                        </FormControl>
                    </div>
                    {filterOptionsError && (
                        <div role="alert">
                            Unable to load act types and vibes.
                            <Button size="small" onClick={this.loadFilterOptions}>Retry filters</Button>
                        </div>
                    )}
                    {this.props.agentActStore.rosterError && (
                        <div role="alert">
                            {this.props.agentActStore.rosterError}
                            <Button size="small" onClick={this.retryRoster}>Retry</Button>
                        </div>
                    )}
                    {hasSearch && !isSearchingActRoster && (
                        <div style={{ 
                            fontSize: 13, 
                            color: "#666",
                            marginBottom: 8,
                            padding: "4px 0"
                        }}>
                            <strong>{filteredActs.length}</strong> act{filteredActs.length !== 1 ? 's' : ''} found for "<span style={{ color: "#FF0C9C", fontWeight: 500 }}>{actRosterSearchTerm}</span>"
                        </div>
                    )}

                    <div style={{ position: "relative" }}>
                        <Loading showed={isLoadingAcceptedActs} />
                        <ActRosterTable 
                            acts={filteredActs}
                            genreCatalog={this.props.lookupStore.genres}
                            onCreateBooking={this.createBooking}
                            onViewContact={this.handleOpenContactDialog}
                            onSendMessage={this.handleButtonMessage}
                            onUpdateInvoice={this.handleOpenActInvoiceSetting}
                            onViewSuper={this.openSuperLedgerPreviewDetails}
                            onRemove={this.handleOpenDeleteModal}
                            onViewDocuments={this.handleOpenDocumentsModal}
                            onDownloadImages={this.handleOpenImagesModal}
                        />
                        {hasSearch ? (
                            this.props.agentActStore.isMoreAgentAct && (
                                <div style={{ textAlign: "center", padding: "16px 0" }}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={this.handleShowMore}
                                        disabled={isLoadingAcceptedActs}
                                        style={{ color: "#FF0C9C", borderColor: "#FF0C9C" }}
                                    >
                                        Load More Results
                                    </Button>
                                </div>
                            )
                        ) : (
                            <PaginationToolbar totalFilteredCount={filteredActs.length} />
                        )}
                    </div>
                </Paper>

                <Dialog
                    open={contactDialogOpen}
                    onClose={this.handleCloseContactDialog}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle style={{ paddingBottom: 0, position: "relative" }}>
                        <Typography variant="h6">Contact Details</Typography>
                        <IconButton 
                            onClick={this.handleCloseContactDialog} 
                            size="small"
                            style={{ position: "absolute", right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: 16, paddingBottom: 24 }}>
                        {contactDialogData && (
                            <>
                                <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #eee" }}>
                                    <Typography variant="subtitle2" style={{ color: "#999", marginBottom: 4 }}>Act Name</Typography>
                                    <Typography variant="body1" style={{ fontWeight: 500 }}>{contactDialogData.actName || contactDialogData.fullName || "-"}</Typography>
                                    <Typography variant="subtitle2" style={{ color: "#999", marginBottom: 4, marginTop: 12 }}>Act Owner</Typography>
                                    <Typography variant="body1" style={{ fontWeight: 500 }}>{contactDialogData.myMusician?.fullName || "-"}</Typography>
                                </div>
                                {contactDialogData.contactPhone && (
                                    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                                        <div style={{ width: 40, height: 40, background: "#f5f5f5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <PhoneIcon style={{ color: "#ff0c9c" }} />
                                        </div>
                                        <div>
                                            <Typography variant="caption" style={{ color: "#999", textTransform: "uppercase", letterSpacing: 0.5, display: "block" }}>Phone</Typography>
                                            <Typography variant="body1">
                                                <a href={`tel:${contactDialogData.contactPhone}`} style={{ color: "#ff0c9c", textDecoration: "none" }}>
                                                    {contactDialogData.contactPhone}
                                                </a>
                                            </Typography>
                                        </div>
                                    </div>
                                )}
                                {(contactDialogData.contactEmail || contactDialogData.actAdmin?.email) && (
                                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                        <div style={{ width: 40, height: 40, background: "#f5f5f5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <EmailIcon style={{ color: "#ff0c9c" }} />
                                        </div>
                                        <div>
                                            <Typography variant="caption" style={{ color: "#999", textTransform: "uppercase", letterSpacing: 0.5, display: "block" }}>Email</Typography>
                                            <Typography variant="body1">
                                                <a href={`mailto:${contactDialogData.contactEmail || contactDialogData.actAdmin?.email}`} style={{ color: "#ff0c9c", textDecoration: "none" }}>
                                                    {contactDialogData.contactEmail || contactDialogData.actAdmin?.email}
                                                </a>
                                            </Typography>
                                        </div>
                                    </div>
                                )}
                                {!contactDialogData.contactPhone && !contactDialogData.contactEmail && !contactDialogData.actAdmin?.email && (
                                    <Typography variant="body1" style={{ color: "#999", textAlign: "center", padding: "20px 0" }}>
                                        No contact details available
                                    </Typography>
                                )}
                            </>
                        )}
                    </DialogContent>
                </Dialog>

                <ActInvitationModal
                    open={actInvitationModalState}
                    onClose={this.closeActInvitationModal}
                    profileType="agent"
                    handleEmpty={this.openActOwnerInvitationModal}
                />
                <ActOwnerInvitationModal open={this.state.actOwnerInvitationModalState} onClose={this.closeActOwnerInvitationModal} />

                <ConfirmationModal
                    open={this.state.deleteActModalState}
                    message="Are you sure you want to remove this act? Your current bookings with this act will be removed."
                    closeHandler={this.handleCloseDeleteModal}
                    confirmationHandler={this.handleDeleteAct}
                    declineHandler={this.handleCloseDeleteModal}
                    confirmationLabel="Remove"
                />

                <InvoiceAgentActModal
                    open={this.state.openActInvoiceSetting}
                    onClose={this.handleCloseActInvoiceSetting}
                    data={this.state.agentAct}
                />
                <HGSuperPayEmployeeModal
                    open={this.state.openSuperLedgerDetailsModal}
                    onClose={this.closeSuperLedgerDetailsModal}
                    contactId={this.state.employeeModalContactId}
                    employerProfileId={this.props.profileStore.currentProfile ? this.props.profileStore.currentProfile.id : null}
                    contactName={this.state.employeeModalContactName}
                    showActions={false}
                />

                <ActDocumentsModal
                    open={documentsModalOpen}
                    onClose={this.handleCloseDocumentsModal}
                    act={documentsModalAct}
                />

                <ActImagesModal
                    open={imagesModalOpen}
                    onClose={this.handleCloseImagesModal}
                    act={imagesModalAct}
                />
            </Fragment>
        );
    }
}

export default AgentActRoster;
